import { AssistantState } from './assistant.state';

/**
 * Initialer State des Assistent-Panels.
 *
 * Die Reset-Action stellt daraus die Sichtbarkeit wieder her, wenn der
 * Standalone-Bereich verlassen wird - sonst würde das Panel beim
 * Wiedereintritt ungefragt aufgehen. Die Größe nimmt sie ausdrücklich aus.
 *
 * `'small'` gilt nur, solange noch nichts gemerkt ist; liegt eine frühere
 * Wahl im Browser, meldet sie der Effect beim Start nach.
 */
export const assistantStateInitial: AssistantState = {
  isOpen: false,
  size: 'small',
};
